import { Typography } from "@mui/material";
import { fonts } from "fonts";

export default function ShimeringText({ children }) {
  return (
    <Typography
      m={1}
      // variant="caption"
      fontFamily={fonts.geist}
      fontStyle="italic"
      sx={{
        display: "inline-block",
        background: `
          linear-gradient(
            90deg,
            #999 0%,
            #fff 50%,
            #999 100%
          )
        `,
        backgroundSize: "200% 100%",
        color: "transparent",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        animation: "text-sweep 3s linear infinite",
        "@keyframes text-sweep": {
          "0%": { backgroundPosition: "200% 0" },
          "100%": { backgroundPosition: "-200% 0" },
        },
      }}
    >
      {children}
    </Typography>
  );
}
